import { useState } from "react";
import axios from 'axios'

function usePostData(url) {
    const [Loading, setLoading] = useState(false);
    const [error, seterror] = useState(null)
    const postData = async (bodyData) => {
        try {
            setLoading(true);
            let resposne = await axios.post(url,
                bodyData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )
            return resposne.data;
        } catch (err) {
            seterror(err);
        } finally {
            setLoading(false);
        }
    }

    return { Loading, error, postData }

}

export default usePostData;